var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82143 5.82143C6.82143 4.34152 8.02009 3.14286 9.5 3.14286C10.5681 3.14286 11.4888 3.76562 11.9208 4.67299C12.1752 5.2087 12.8147 5.43638 13.3471 5.18192C13.8795 4.92746 14.1105 4.28795 13.856 3.75558C13.0826 2.12835 11.4252 1 9.5 1C6.83817 1 4.67857 3.1596 4.67857 5.82143V7.42857H4.14286C2.96094 7.42857 2 8.38951 2 9.57143V16C2 17.1819 2.96094 18.1429 4.14286 18.1429H14.8571C16.0391 18.1429 17 17.1819 17 16V9.57143C17 8.38951 16.0391 7.42857 14.8571 7.42857H6.82143V5.82143Z",
    fill: "#2C405A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.96dfe51b520a3a9d15743f1d023c3527.svg";
export { ForwardRef as ReactComponent };